import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

/**
 * BeeCurrency, pipe to transform a number to euros.
 */
@Pipe({
  name: 'beeCurrency'
})
export class BeeCurrencyPipe implements PipeTransform {

  /**
   * Pipe transform.
   * @param value
   * @param args
   */
  transform(value: any, args?: any): any {
    return new CurrencyPipe('es').transform(value, 'EUR', 'symbol');
  }
}
